import { useState, useEffect, useRef } from "react";
import { Button, Form, Icon, Modal, Popup, Table } from "semantic-ui-react";
import { Trash, Eye } from 'phosphor-react';
import { toast } from 'react-toastify';
import moment from "moment";

import { ExpensesService } from "../../services/methods/ExpensesService";
import { OsService } from "../../services/methods/OsService";

import { useSchedule } from "../../hooks/schedules";
import { useUser } from "../../hooks/user";

import { IExpenseResponse, ISchedule } from "../../interfaces/ISchedule";
import { IExpensesData } from "../../interfaces/IExpenses";

import { getBase64 } from "../../utils/getBase64";
import { styleSheet } from "../../assets/styles/global";

import {
  Title,
  Input,
  OutgoingContainer,
  TableColumnText,
  TableDataText,
  ButtonTable
} from './styles'

interface Props {
  visible: boolean;
  closeModal: () => void;
  data: ISchedule;
}

interface IOptions {
  cod: string;
  descr: string;
  qtdmax: string;
  valmax: string;
}

interface IExpense {
  vlr: number;
  cod: string;
  img?: string;
  imgName?: string;
}

interface IProjeto {
  tiposdesp: {
    cod: string;
    descr: string;
    qtdmax: string;
    valmax: string;
  }
}

export const OutgoingOSModal = ({ visible, closeModal, data }: Props) => {
  const expensesService: ExpensesService = new ExpensesService();
  const osService: OsService = new OsService();

  const [options, setOptions] = useState<IOptions[]>([])
  const [option, setOption] = useState('SELECIONE')
  const [value, setValue] = useState('')
  const [file, setFile] = useState('')
  const [fileName, setFileName] = useState('')
  const [values, setValues] = useState({ val: [{} as IExpense] });
  const [isFirstExpense, setIsFirstExpense] = useState(true);
  const [loadExpense, setLoadExpense] = useState(false);

  const inputRef = useRef<HTMLInputElement>({} as HTMLInputElement);

  const {
    updateSchedulesData,
    setReceiveIsUpdate,
    isVisualOutgoingOSModal,
    setIsLoading,
    analyst
  } = useSchedule()

  const { userInfo } = useUser();

  function createInputs() {
    if (isFirstExpense) return

    return (
      <OutgoingContainer>
        <Title>Despesas</Title>
        <Table celled compact  sortable selectable color='blue'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <TableColumnText>
                  Tipo
                </TableColumnText>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <TableColumnText>
                  Valor
                </TableColumnText>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <TableColumnText>
                  Arquivo
                </TableColumnText>
              </Table.HeaderCell>
              <Table.HeaderCell width={1}>
                <TableColumnText>
                  Opção
                </TableColumnText>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {values.val.map((el, i) => (
              <Table.Row key={i}>
                <Table.Cell><TableDataText>{options.find(option => option.cod === el.cod)?.descr}</TableDataText></Table.Cell>
                <Table.Cell><TableDataText>{el.vlr}</TableDataText></Table.Cell>
                <Table.Cell><TableDataText>{el.img ? el.imgName : 'Nenhum Arquivo Selecionado'}</TableDataText></Table.Cell>
                <Table.Cell width={1}>
                  <TableDataText>
                    <Popup
                      trigger={
                        <ButtonTable 
                          onClick={() => {
                            removeClick(i)
                          }}
                        >
                          <Trash size={20} color="#E47261" />
                        </ButtonTable>
                      }
                      content={<span style={{ fontSize: '1.3rem' }}>Excluir</span>}
                      inverted
                    />
                    {
                      el.img && 
                      <Popup
                        trigger={
                          <ButtonTable 
                            onClick={() => {
                              handleViewPhoto(i)
                            }}
                          >
                            <Eye size={20} color="#6FCCF1" />
                          </ButtonTable>
                        }
                        content={<span style={{ fontSize: '1.3rem' }}>Visualizar</span>}
                        inverted
                      />
                    }
                  </TableDataText>
                </Table.Cell>
              </Table.Row>
            ))}
          
          </Table.Body>
        </Table>
      </OutgoingContainer>
    )
  }

  const handleAddnewExpense = () => {
    if (option === 'SELECIONE') {
      return toast.error('Selecione um tipo')
    }
    if (value === '' || value === '0') {
      return toast.error('O campo valor é obrigatorio.')
    }
    const maxVal = options.find(opt => opt.cod.includes(option))?.valmax
    const maxQtd = options.find(opt => opt.cod.includes(option))?.qtdmax
    if (Number(value) > Number(maxVal!)) {
      return toast.error(`O limite para esse tipo de despesa é R$${maxVal}`)
    }
    let qtd = 0;
    values.val.map(val => {
      if (val.cod === option) {
        qtd++
      }
      return val
    })

    if (qtd >= Number(maxQtd!)) {
      return toast.error(`A quantidade maxima desse tipo é ${maxQtd}`)
    }

    if (isFirstExpense) {
      setValues({ val: [{ vlr: Number(value), cod: option, img: file, imgName: fileName }] })
    } else {
      setValues({ val: [...values.val, { vlr: Number(value), cod: option, img: file, imgName: fileName }] })
    }
    setIsFirstExpense(false)
    setValue('')
    setFile('')
    setFileName('')
    setOption('SELECIONE')
  }

  const removeClick = (index: number) => {
    let vals = [...values.val];
    vals.splice(index, 1);
    setValues({ val: vals });
  }

  const handleViewPhoto = (index: number) => {
    const vals = [...values.val];
    const despesa = vals[index]

    const newTab = window.open();
    newTab?.document.write(
      `<!DOCTYPE html><head><title>${despesa.imgName}</title></head><body><img src="${despesa.img}" width="700px" height="700px" ></body></html>`);
    newTab?.document.close();
  }

  const handleOsOutgoing = async () => {

    const token = await sessionStorage.getItem('token')

    if (values.val.length <= 0) {
      return toast.info('Adicione um despesa para lançar.')
    }

    try {
      setLoadExpense(true);
      setIsLoading(true);
      const expenseData: IExpensesData = {
        os: String(data.os),
        despesas: values.val,
        token
      }

      const response = await expensesService.launchExpense(expenseData)


      if (response.data.status === 'ok') {
        toast.success(response.data.msg)
        setOptions([])

        closeModal()
        const analista =  (userInfo.cargo === 'C' && analyst !== "") ? analyst : userInfo.codigo
        const { data: dataResponse } = await osService.getOs(data.key, analista, token!)
        if (dataResponse.status === 'ok') {
          await updateSchedulesData(dataResponse.analista)
        } else {
          toast.error('Ops... Algo deu errado tente novamente.')
          window.location.reload();
        }
      } else {
        toast.error(response.data.msg)
        return
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setLoadExpense(false);
      setIsLoading(false);
      setReceiveIsUpdate(false);
    }
  }

  async function loadProjectExpenseData() {
    setLoadExpense(true);
    try {
      const token = await sessionStorage.getItem('token')

      const response = await expensesService.getProjectExpense(token, data.codpro)

      if (response.data.status === 'ok') {
        const arrayOptions = [] as IOptions[];
        response.data.projeto.map((pro: IProjeto) => {
          arrayOptions.push({
            cod: pro.tiposdesp.cod,
            descr: pro.tiposdesp.descr,
            qtdmax: pro.tiposdesp.qtdmax,
            valmax: pro.tiposdesp.valmax
          })
          return pro
        })
        setOptions(arrayOptions)
      } else {
        toast.error(response.data.msg)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    }
  }

  async function loadExpenseData() {
    try {
      const token = await sessionStorage.getItem('token')

      const response = await expensesService.getExpense(token, data.os)

      if (response.data.status === 'ok') {
        console.log(response)

        setValues({
          val: response.data.dados.map((despesa: IExpenseResponse) => {
            return {
              vlr: despesa.valor,
              cod: despesa.despesa,
              img: despesa.dataImage,
              imgName: despesa.nameImage,
            }
          })
        })
        setIsFirstExpense(false)
      } else {
        toast.error(response.data.msg)
      }
    } catch (error: any) {
      if (error.response) {
        if(error.response.data.errorMessage.includes('registro informado não encontrado')) {
          return 
        } else {
          toast.error(error.response.data.errorMessage)
        }
      }
    } finally {
      setLoadExpense(false);
    }
  }

  async function handleSetFiles(files: FileList | null) {
    var filesArr = Array.prototype.slice.call(files);
    const fileResponse: string = await getBase64(filesArr[0]);

    setFileName(filesArr[0].name);
    setFile(fileResponse);
  }

  useEffect(() => {
    if (!isVisualOutgoingOSModal) {
      loadProjectExpenseData();
      loadExpenseData();
    }
  }, [])

  return (
    <Modal
      open={visible}
      closeIcon
      onClose={closeModal}
      size="large"
      closeOnDimmerClick={false}
      style={{ fontFamily: styleSheet.mainFont }}
    >
      <Modal.Header>{data.nomecli} - {data.projeto} {moment(data.data).format('DD/MM/YYYY')}</Modal.Header>

      <Modal.Content scrolling style={{ width: '100%', minHeight: '500px' }}>
        {/* { loadExpense && <Load><Loader active>Carregando</Loader></Load> } */}

        <Form style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between', gap: '1.5rem', flexGrow: '1' }}>
          <Form.Field required={true} style={{ width: '35%' }} >
            <Form.Select 
              style={{ height: '4rem', fontSize: '1.3rem', lineHeight: '1.9rem' }}
              fluid
              label="Tipo"
              placeholder="Tipos de despesas"
              options={options.map(option => { return { key: option.cod, text: option.descr, value: option.cod } })}
              onChange={(ev, { value }) => {
                setOption(String(value));
              }}
              value={option}
              loading={loadExpense}
            />
          </Form.Field>

          <Form.Field required={true} style={{ width: '35%' }} >
            <Form.Input 
              style={{ height: '4rem', fontSize: '1.3rem', lineHeight: '1.9rem' }}
              fluid
              label="Valor"
              type="number"
              placeholder="Valor da despesa"
              onChange={(ev, { value }) => {
                setValue(value);
              }}
              value={value}
            />
          </Form.Field>
          <Form.Field required={true} style={{  marginTop: '14px' }}>
            <Button style={{ height: '4rem', fontSize: '1.3rem' }} icon labelPosition='left' size="big" color="blue" onClick={() => inputRef.current.click()}>
              <Icon name='cloud' />
              {file ? 'Arquivo armazenado' : 'Selecione arquivo'}
              <Input ref={inputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleSetFiles(e.target.files)} />
            </Button>
          </Form.Field>
          <Form.Field required={true}  style={{ alginSelf: 'flex-end', marginTop: '4px' }}>
            <Button style={{ height: '4rem', fontSize: '1.3rem' }} icon  size="big" color="green" onClick={handleAddnewExpense}>
              <Icon name='plus' />
            </Button>
          </Form.Field>
        </Form>

        
        {createInputs()}

      </Modal.Content>

      <Modal.Actions>
        <Button.Group size='big'>
          <Button onClick={closeModal}>Cancelar</Button>
          { !isVisualOutgoingOSModal && <Button.Or text="ou" /> }
          { !isVisualOutgoingOSModal && <Button onClick={handleOsOutgoing} positive>Lançar Despesa</Button> }
        </Button.Group>
      </Modal.Actions>
    </Modal>
  )
}
